<template>
  <div class="page-class page-center">
    <div class="page-staff-form">
      <h1 class="page-title text-center">{{ title }}</h1>
      <kyc-form-box list-url="/kyc" user-type="user" :form-type="formType" :mobile="mobile" @add="onAdd" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import KycFormBox from '@/components/KycFormBox.vue';

export default {
  name: 'UserForm',
  components: {
    KycFormBox
  },
  async mounted() {
    await this.getPinCodeList({
      type: 'user'
    });
  },
  data() {
    return {
      formType: 'new',
      mobile: null
    };
  },
  computed: {
    title() {
      return 'Sampark Form';
    },
    ...mapState('user', ['availableRoles']),
    ...mapState('kyc', ['loading'])
  },
  methods: {
    ...mapActions('kyc', ['getPinCodeList', 'postOne']),
    onAdd({ kyc }) {
      this.postOne({
        type: 'user',
        kyc,
        router: this.$router,
        redirectUrl: '/kyc'
      });
    }
  }
};
</script>
